module.exports = __webpack_public_path__ + "img/undset_Portrett3.f594e01f.jpg";